import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'
import Icon from '../../util/Icon'
import PremiumLabel from '../website/settings/Form/PremiumLabel'
import classnames from 'classnames'
import types from './types'

import IntegrationsStore from '../../../stores/integrations'

import { ZapierTemplate } from '../../injected_scripts'
import { isPremium as isPremiumUtil } from '../../../utils/plans'

const MAX_ALLOWED = 3

@inject('auth')
@observer
export default class Integrations extends Component {
  integrations = new IntegrationsStore()

  componentDidMount() {
    this.integrations.load()
  }

  isPremium() {
    return isPremiumUtil(this.props.auth.user.license_plan)
  }

  renderIntegration = integration => {
    const statusLabel = this.isPremium() ? integration.paused ? 'Paused' : 'Live' : 'Suspended'
    const statusIcon = this.isPremium() ? integration.paused ? 'pause-circle' : 'check-circle' : 'exclamation-circle'
    return (
      <tr key={integration.id} className={classnames('integration-added', { disabled: !this.isPremium() })}>
        <td><span className="integration-logo" style={{backgroundImage: `url(/images/integrations/${types[integration.type].image})`}} /> {types[integration.type].name}</td>
        <td><strong>{integration.name}</strong></td>
        <td><span className="owner-type">{integration.owner_type.replace(/Team/, 'Account')}</span></td>
        <td>{integration.owner_name}</td>
        <td><Icon icon={statusIcon} /> {statusLabel}</td>
        <td><Link className="button" to={`/integrations/edit/${integration.id}`}>Edit</Link></td>
      </tr>
    )
  }

  handleAdd = event => {
    if (this.integrations.records.filter(i => !i.paused).length >= MAX_ALLOWED) {
      event.preventDefault()
      alert('You must delete or pause one of your existing integrations before you can add another.')
    }
  }

  getAddLink(integration) {
    if (integration.type === 'Zapier') {
      return (
        <a className="button" href="https://zapier.com/developer/invite/97293/945a58c4e0281fb0426d783c92e165fe/" target="_blank">Add</a>
      )
    } else if (this.isPremium()) {
      return (
        <Link className="button" onClick={this.handleAdd} to={`/integrations/add/${integration.type}`}>Add</Link>
      )
    } else {
      return (
        <Link className="button" to="/billing/upgrade">Upgrade Now</Link>
      )
    }
  }

  renderAvailableIntegration = integration => {
    return (
      <div key={integration.type} className="integration-available">
        <div className="image">
          <img src={`/images/integrations/${types[integration.type].image}`} />
        </div>
        <div className="details">
          <div className="title">
            <strong>{types[integration.type].name}</strong>
            {types[integration.type].via ? <span>via {types[types[integration.type].via].name}</span> : null}
            <em>{types[integration.type].kind}</em>
          </div>
          <div className="supports">
            {types[integration.type].supports.map(opt => (
              <div key={opt}><Icon icon="check" /> {opt}</div>
            ))}
            <a href={types[integration.type].url} target="_blank">{types[integration.type].url.replace(/^https?\:\/\//, '')}</a>
          </div>
        </div>
        <div className="actions">{this.getAddLink(integration)}</div>
      </div>
    )
  }

  renderAddedIntegrations() {
    if (this.integrations.records.length)
    return (
      <div>
        <h3>Added Integrations <em>{this.integrations.records.filter(i => !i.paused).length} Live of {MAX_ALLOWED}</em></h3>
        <div className="added-integrations">
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Name</th>
                <th>Level</th>
                <th>Owner</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.integrations.map(this.renderIntegration)}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  renderAvailableIntegrations() {
    const ints = this.integrations.available.map(i => ({ type: i.type, ...types[i.type] }))
    const vias = this.getViaedIntegrations()

    const all = [...ints, ...vias].sort((a, b) => a.name === b.name ? 0 : a.name > b.name ? 1 : -1)

    const shown = all.filter(int => {
      if (int.hidden) return false
      if (int.via) {
        const via = types[int.via]
        if (via.hidden) return false
      }
      return true
    })

    return (
      <div>
        <h3>Add an Integration <em>Up to {MAX_ALLOWED} Live Integrations</em></h3>
        <div className="available-integrations">
          {shown.map(this.renderAvailableIntegration)}
        </div>
      </div>
    )
  }

  getViaedIntegrations() {
    const viaed = []
    for (let type in types) {
      const t = types[type]
      if (this.integrations.available.find(i => i.type === t.via)) {
        viaed.push({ type, ...types[type] })
      }
    }
    return viaed
  }

  render() {
    if (!this.integrations.loaded) {
      return <div className="loading">Loading...</div>
    }

    return (
      <div className="container centered padded integrations">
        <div className="panel full padded">
          <h2 className="title">Premium Integrations</h2>

          <PremiumLabel>Premium Integrations Are Available On Premium Plan Only</PremiumLabel>
          
          {this.renderAddedIntegrations()}
          {this.renderAvailableIntegrations()}
        </div>
        
        <div className="panel full padded">
          <h2 className="title">Other Integrations</h2>

          <div>
            <h3>Add an Integration via Zapier</h3>
            <ZapierTemplate />
          </div>

        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// client/components/sections/Integrations/index.js